import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PRICES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getProductDepositAction = createAsyncThunk(
    'price/getProductDepositAction',
    async (productId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PRICES_PATH }/deposit?productId=${ productId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductDepositSlice = createSlice({
    name: 'getProductDepositSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateProductDeposit() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getProductDepositAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductDepositAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductDepositAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateProductDeposit } = getProductDepositSlice.actions;
export const getProductDepositState = (state) => state.price.getProductDeposit;
export default getProductDepositSlice.reducer;